import React from "react";

import BoardHeader from "./components/BoardHeader/BoardHeader";
import Loader from "../../components/Loader";
import BoardWorklogComp from "./components/worklog/BoardWorklogComp";
import GanttChart from "./components/milestoneGantchart/GantChart";
import "./boardStyle.scss";
import BoardDetailController from "./controllers/BoardDetailController";
import BoardKanbanController from "./controllers/BoardKanbanController";
import BoardListController from "./controllers/BoardListController";
import { useBoardPageState } from "./hooks/useBoardPageState";

function BoardPage({ showCardPopup = false }) {
  const {
    board,
    boardId,
    cardId,
    cards,
    cardsOnBoard,
    contentOffsetClass,
    gridView,
    isCardsLoading,
    isLoading,
    loading,
    listCards,
    permissionState,
    setLoading,
    viewState,
  } = useBoardPageState(showCardPopup);
  const shouldShowCardPopup = showCardPopup || Boolean(cardId);

  return (
    <>
      <BoardDetailController
        boardId={boardId}
        cardId={cardId}
        cardsOnBoard={cardsOnBoard}
        showCardPopup={shouldShowCardPopup}
      />
      {isLoading ? (
        <div className="loader-center">
          <Loader color={"black"} />
        </div>
      ) : (
        <>
          {permissionState.hasWorkflow && (
            <BoardHeader
              boardName={{ data: { responseData: board } }}
              boardId={boardId}
              ownerId={permissionState.ownerId}
              workflowId={permissionState.workflowId}
              setLoading={setLoading}
            />
          )}

          <div className={contentOffsetClass}>
            {permissionState.errorMessage && (
              <div className="loader-center">{permissionState.errorMessage}</div>
            )}
          </div>

          {viewState.isGanttChartView ? (
            <GanttChart />
          ) : (
            permissionState.hasWorkflow &&
            (viewState.isWorklogView ? (
              <BoardWorklogComp />
            ) : gridView ? (
              <BoardKanbanController
                board={board}
                boardId={boardId}
                cards={cards}
                loading={loading}
                workflowId={permissionState.workflowId}
              />
            ) : (
              <BoardListController
                allCardsByBoard={cards}
                board={board}
                cards={listCards}
                isCardsLoading={isCardsLoading}
                isMilestoneView={viewState.isMilestoneView}
                setLoading={setLoading}
                workflowId={permissionState.workflowId}
              />
            ))
          )}
        </>
      )}
    </>
  );
}

export default BoardPage;
